<template>
  <div class="filter-set wide feature-group">
    <button
      class="filter-name"
      @click.stop="$emit('toggle')"
      :class="getBoxClass()"
      type="button"
      :aria-expanded="expanderVisible ? 'true' : 'false'"
      :aria-controls="id + '-feature-group-panel'"
      :id="id + '-feature-group-toggle'"
    >
      <span class="filter-name__label">{{ currentGroupName }}</span>
      <i class="toggle-expander icon-chevron-down"></i>
    </button>
    <expander :expanded="expanderVisible">
      <div
        class="listing-group-input"
        :id="id + '-feature-group-panel'"
        role="region"
        :aria-labelledby="id + '-feature-group-toggle'"
      >
        <a
          v-for="(route, index) in getFeatureGroupLinks"
          :class="getLinkClass(route.path)"
          :key="`feature-${index}`"
          :href="route.path"
          @click.prevent="navigateTo(route.path)"
          role="button"
          tabindex="0"
          :aria-current="route.path === route.path ? 'page' : undefined"
        >
          {{ route.name }}
        </a>
      </div>
    </expander>
  </div>
</template>
<script lang="ts">
import utils from '@/app/utils/utils';
import Expander from '../expander/expander.vue';
import config from '@/config';
import { search } from '@/app/routes';
import { getFeatureGroupById } from '@/config/featureGroups';
import useSafeRoute from '@/app/composables/useSafeRoute';

export default {
  name: 'feature-group',
  setup() {
    const route = useSafeRoute();
    return { route };
  },
  data: () => ({
    id: `feature-group-${utils.newId()}`,
    key: 'featureGroup',
    search,
  }),
  props: {
    expanderVisible: {
      type: Boolean,
      default: undefined, // By default, the expander is visible but without any complex close/open css logic
    },
    currentGroup: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: '',
    },
  },
  computed: {
    rentalMode() {
      return this.mode === config.SEARCH_MODES.RENTAL;
    },
    getFeatureGroupLinks() {
      return this.rentalMode
        ? this.search.rental.routes.filter((route) => !route.notSearchRoute)
        : this.search.sale.routes.filter((route) => !route.notSearchRoute);
    },
    currentGroupName() {
      return getFeatureGroupById(this.currentGroup)?.name;
    },
  },
  methods: {
    getBoxClass() {
      return this.expanderVisible;
    },
    getLinkClass(path: string) {
      return this.route.path.includes(path) ? 'feature-group__link is-selected' : 'feature-group__link';
    },
    navigateTo(path: string) {
      this.$emit('toggle');
      if (this.route.path !== path) {
        void this.$router.push(path);
      }
    },
  },
  mounted() {
    this.id = this.$.uid.toString();
  },
  components: {
    Expander,
  },
};
</script>
